import "regenerator-runtime/runtime";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

const connector = new AppSearchAPIConnector({
	searchKey: process.env.VUE_APP_ELASTIC_KEY ||  ((process.env.NODE_ENV === "production") ? "search-zcw171fwuz5e2eo44z9si9wh" : "search-9zf4iv66ia8845tirysphiib"),
  engineName: "banco-sentencas-engine",
  endpointBase: process.env.VUE_APP_ELASTIC_URL || ((process.env.NODE_ENV === "production" ) ? process.env.VUE_APP_ELASTIC_URL || "/es" : ""),/* http://ent-search.banco-sentencas-dev.apps.oc.i.tj.pa.gov.br:3002/ */  cacheResponses: false
});

const config = {
  debug: true,
  apiConnector: connector,
  searchQuery: {
    disjunctiveFacets: [
      "assuntos",
      "classe",
      "competencia",
      "pessoas",
      "orgaojulgador",
      "datadocumento"
    ],
    facets: {
      assuntos: {
        type: "value"
      },
      classe: {
        type: "value"
      },
      competencia: {
        type: "value"
      },
      pessoas: {
        type: "value"
      },
      orgaojulgador: {
        type: "value"
      },
      datadocumento: {
        type: "value"
      }
    }
  }
};

export default config;
